import React, { useEffect, useState } from "react";
import { db } from "../services/firebase";
import { ref, onValue, get } from "firebase/database";
import "./VersionDisplayPanel.css";

function VersionDisplayPanel({ user }) {
  const [versions, setVersions] = useState({});
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user?.uid) {
      get(ref(db, `admins/${user.uid}`)).then((snap) => {
        if (snap.exists()) {
          setIsAdmin(true);
        }
        setLoading(false);
      });
    }
  }, [user]);

  useEffect(() => {
    if (!isAdmin) return;

    const versionRef = ref(db, "Update/version");
    onValue(versionRef, (snap) => {
      setVersions(snap.val() || {});
    });
  }, [isAdmin]);

  const toDisplayVersion = (key) => key.replace(/_/g, ".");

  const renderVersionsByCategory = (category) => {
    const categoryVersions = [];

    const recursiveCollect = (data, base = "") => {
      Object.entries(data).forEach(([key, value]) => {
        const fullKey = base ? `${base}/${key}` : key;

        if (value && typeof value === "object") {
          if (value.category === category) {
            categoryVersions.push({ key: fullKey, data: value });
          }

          // Recurse deeper
          Object.entries(value).forEach(([subKey, subValue]) => {
            if (
              typeof subValue === "object" &&
              !["features", "title", "date", "type", "category"].includes(subKey)
            ) {
              recursiveCollect({ [subKey]: subValue }, fullKey);
            }
          });
        }
      });
    };

    recursiveCollect(versions);

    if (categoryVersions.length === 0) return <p>No {category} versions found.</p>;

    return (
      <div className="version-group">
        <h3>
          {category === "current" && "📌 Current Version"}
          {category === "planned" && "🔮 Planned Versions"}
          {category === "history" && "📗 Version History"}
        </h3>

        {categoryVersions.map(({ key, data }) => (
          <details key={key} open>
            <summary>
              {toDisplayVersion(key)} — <strong>{data.title || "Untitled"}</strong>
              {data.type && ` (${data.type})`}
            </summary>
            {data.date && <p><strong>Date:</strong> {data.date}</p>}
            {data.type && <p><strong>Type:</strong> {data.type}</p>}
            {Array.isArray(data.features) && data.features.length > 0 && (
              <ul>
                {data.features.map((f, i) => (
                  <li key={i}>{f}</li>
                ))}
              </ul>
            )}
          </details>
        ))}
      </div>
    );
  };

  if (loading) return <p>Loading...</p>;
  if (!isAdmin) return <p>⛔ Access Denied. Admins only.</p>;

  return (
    <div className="version-display-panel">
      <h2>🛠️ Internal Version Log Viewer (Admin Only)</h2>
      {renderVersionsByCategory("current")}
      {renderVersionsByCategory("planned")}
      {renderVersionsByCategory("history")}
    </div>
  );
}

export default VersionDisplayPanel;
